import { FC } from 'react'
import { Box } from '@mui/material'
import ReportExportButton from '../../../components/ReportExportButton'
import ConfigurationSettingsButton from '../../../components/ConfigurationSettingsButton'
import SettingsButton from '../../../components/SettingsButton'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'

interface Props {
  showReport: boolean
  disabledReport: boolean
  isExportingReport: boolean
  handleReportExport: () => void
  handleOpenDrawer: () => void
}

const LibraryDetailsHeaderActions: FC<Props> = ({
  showReport,
  disabledReport,
  isExportingReport,
  handleReportExport,
  handleOpenDrawer
}) => {
  const { authUser, active } = useLibraryDetails()

  return (
    <Box className="actions-wrapper">
      <ReportExportButton
        showReport={showReport}
        authUser={authUser}
        isExporting={isExportingReport}
        disabled={disabledReport}
        handleExport={handleReportExport}
      />

      {active ? (
        <ConfigurationSettingsButton authUser={authUser} handleOpenDrawer={handleOpenDrawer} />
      ) : (
        <SettingsButton authUser={authUser} handleOpenDrawer={handleOpenDrawer} />
      )}
    </Box>
  )
}

export default LibraryDetailsHeaderActions
